import { render, staticRenderFns } from "./image-text-row.vue?vue&type=template&id=c68f4016&"
import script from "./image-text-row.vue?vue&type=script&lang=js&"
export * from "./image-text-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c68f4016')) {
      api.createRecord('c68f4016', component.options)
    } else {
      api.reload('c68f4016', component.options)
    }
    module.hot.accept("./image-text-row.vue?vue&type=template&id=c68f4016&", function () {
      api.rerender('c68f4016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/image-text-row.vue"
export default component.exports